<template>
    <div>
        <nav v-on:keyup.enter="searchRROrder(1)" class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.amount"
                           placeholder="จำนวนเงิน"
                           aria-label="Search"/>
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.rr_number"
                           placeholder="เลขที่ใบ RR"
                           aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        style="width: 170px"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp;
                    <multiselect
                        v-model="search.vendor"
                        class="form-control select"
                        placeholder="ผู้จัดจำหน่าย"
                        :options="optionVendor"
                        :show-labels="false"
                        :customLabel="vendorLabel"
                        track-by="id">
                    </multiselect>
                    &nbsp;
                    <b-form-select v-model="search.status" :options="optionStatus">
                    </b-form-select>
                    &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchRROrder(1)"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="exportExcel"
                            type="button">
                        <icon name="print"></icon>
                        รายงานรับสินค้า
                    </button>
                    &nbsp
                    <router-link to="rr-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            สร้าง RR
                        </button>&nbsp;
                    </router-link>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">เลขใบสั่งซื้อ</th>
                    <th scope="col">วันที่</th>
                    <th scope="col">รหัสผู้จำหน่าย</th>
                    <th scope="col">ชื่อผู้จำหน่าย</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">วันนัดชำระ</th>
                    <th scope="col">สถานะการจ่ายเงิน</th>
                    <th scope="col">ดูรายการ</th>
                    <th scope="col">ลบรายการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rrList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.RR_number }}</td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.vendor_id }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.total | currency }}</td>
                    <td>{{ data.payment_date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-if="data.payment_status_id==1">
                            <span style="color: red">{{ data.payment_status_name }}</span>
                        </template>
                        <template v-else-if="data.payment_status_id==2">
                            <span style="color: green">{{ data.payment_status_name }}</span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <button @click="showRRDetails(data.id)"
                                class="btn btn-default next">
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <template v-if="data.payment_status_id == 2">
                            <icon name="trash-alt" style="color: #999999"></icon>
                        </template>
                        <template v-else>
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash-alt"></icon>
                            </a>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="rrList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getRROrderPage">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-header hide-footer ref="approve">
            <div>
                <br>
                <rr-order-modal @submit="saveRROrderStatus">
                </rr-order-modal>
            </div>
        </b-modal>
        <br>
        <b-modal hide-header hide-footer ref="delete_data">
            <delete-confirm-modal @submit="deleteRROrder"></delete-confirm-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ rrList }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import RrOrderModal from "./RROrderModal";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {domain} from "../../../util/Constants";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import Loading from "../../Utility/Loading";

export default {
    components: {
        Loading,
        DeleteConfirmModal,
        VuePagination,
        DatePicker,
        RrOrderModal, Multiselect, domain
    },
    name: "rr-order-list",
    data() {
        return {
            delete_id: '',
            msg: '',
            status_loading: 1,
            optionStatus: [
                {value: "", text: "เลือกสถานะ"},
                {value: 1, text: "รอการชำระ"},
                {value: 2, text: "ชำระเรียบร้อยแล้ว"},
            ],
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch('RROrder/setRROrder');
        this.$store.dispatch('Vendor/getVendorAll');
    },
    computed: {
        ...mapState({
            rrList: state => {
                return state.RROrder.table;
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            dataPaginate: state => {
                return state.RROrder.dataPaginate;
            },
            search: state => {
                return state.RROrder.search
            }
        })
    },
    methods: {
        exportExcel() {
            this.event_submit = true;
            let data = {
                rr: this.search.rr_number ? this.search.rr_number : '',
                date_start: this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                vendor: this.search.vendor ? this.search.vendor.id : '',
                status: this.search.status ? this.search.status : '',
                excel: 'excel',
                amount: this.search.amount ? this.search.amount : ''
            }
            window.open(`${domain}/rr-order-search?page=1&rr=${data.rr}&date_start=${data.date_start}&date_end=${data.date_end}&vendor=${data.vendor}&status=${data.status}&excel=${data.excel}&amount=${data.amount}`);
        },
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showRRDetails(id) {
            let route = this.$router.resolve({
                name: "rr-form-details",
                query: {id: window.btoa(id)}
            });
            window.open(route.href, '_blank');
        },
        showOrderStatus(id) {
            this.$store.dispatch('RROrder/show', id).then(() => {
                this.$refs.approve.show();
            })
        },
        hideOrderStatus() {
            this.$refs.approve.hide();
        },
        saveRROrderStatus(submitData) {
            if (submitData == 'cancel') {
                this.hideOrderStatus();
            } else {
                this.$store.dispatch('RROrder/update', {
                    id: submitData.id,
                    data: submitData
                })
                    .then(() => {
                        this.hideOrderStatus();
                        this.$store.dispatch('RROrder/setRROrder');
                    });
            }
        },
        searchRROrder(page) {
            this.event_submit = true;
            let data = {
                rr: this.search.rr_number ? this.search.rr_number : '',
                date_start: this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                vendor: this.search.vendor ? this.search.vendor.id : '',
                status: this.search.status ? this.search.status : '',
                excel: '',
                amount: this.search.amount ? this.search.amount : ''
            }
            this.$store.dispatch('RROrder/search', {
                page: page,
                data,
            })
        },
        getRROrderPage() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                this.searchRROrder(page);
            } else {
                //paginate get data
                this.$store.dispatch('RROrder/setRROrder', page)
            }
        },
        deleteRROrder(value) {
            if (value) {
                this.msg = 'กำลังลบรายการ กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("RROrder/delete", this.delete_id).then(() => {
                    this.getRROrderPage();
                    this.hideLoadingModal();
                }).catch(() => {
                    this.msg = 'ลบรายการไม่สำเร็จ';
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
            this.hideLoadingModal();
        }
    }
}
</script>

<style scoped>
.select {
    border: 0
}
</style>
